import {
  getFormattedLocalizedDateNoTime,
  getLocalizedTimeWithSeconds,
} from '$shared/utils/date.utils';

import './cell-timestamp-with-user.scss';

interface CellTimestampWithUserProps {
  timestamp: string | number | null | undefined;
  userLabel?: string | null;
}

export function CellTimestampWithUser({
  timestamp,
  userLabel,
}: CellTimestampWithUserProps) {
  if (!timestamp) return <span>-</span>;

  return (
    <div className="cell-timestamp-with-user flex flex__dir--column">
      <time className="cell-timestamp-with-user__timestamp font-weight-bold">
        {getFormattedLocalizedDateNoTime(timestamp, true)},{' '}
        {getLocalizedTimeWithSeconds(timestamp, true)}
      </time>
      {userLabel ? (
        <span className="cell-timestamp-with-user__user color-gray-800">{userLabel}</span>
      ) : null}
    </div>
  );
}
